export const MAX_IMAGE_DENSITY = 3;

export interface IBriocheImageSize {
  dimension: string;
  amount: number;
}

export function getBriocheImageSize(width: number, height: number): IBriocheImageSize {
  return {
    dimension: width ? 'width' : 'height',
    amount: width || height,
  };
}

export function isBriocheImage(src: string): boolean {
  return src.includes('/brioche/');
}
